import BaseRepository from '@/api/repositories/BaseRepository';

class VehicleManufacturerRepository extends BaseRepository {
	get endpoint() {
		return 'api/vehiclemanufacturer';
	}

	getManufacturerList(searchValue) {
		return this.get('manufacturer', { searchValue });
	}

	getUncheckedManufacturerList(searchValue) {
		return this.index({ uncheck: true, searchValue });
	}

	updateManufacturers(manufacturer) {
		return this.put('manufacturer', {}, manufacturer);
	}
}

export default new VehicleManufacturerRepository();
